import { ValueObject } from 'ddd-base';
import { Message } from '@/constants/index';

export class Password extends ValueObject<{ value: string }> {
    public static readonly RULES = [(value: string) => value.length <= 256 || '256文字以内で入力してください。'];

    get value() {
        return this.props.value;
    }

    get isValid() {
        return !Password.RULES.some((rule) => rule(this.value) !== true);
    }

    get validationMessage() {
        if (!this.value) {
            return Message.NOT_INPUT_ERROR;
        }

        const result = Password.RULES.find((rule) => rule(this.value) !== true);
        if (result) {
            return result(this.value) as string;
        }

        return '';
    }
}
